module.exports = __webpack_public_path__ + "img/woman.a3d3f39c.jpg";